export const PERSISTENCE_KEYS = {
  ACCOUNT_MANAGEMENT_SELECTED_COUNTERPARTY: 'acc-mgm-sel-cpy',
  USER_ROLE_MANAGEMENT_ROLES: 'usr-mng-rls-exp',
  USER_ROLE_MANAGEMENT_BRANCH_ROLES: 'usr-mng-br-rls-exp',
};
